import React from 'react';
import { Link } from 'react-router-dom';
// import './IntroCard.css';

const IntroCard = ({ isAuthenticated }) => {
  return (
    <div className="intro-card">
      <div className="intro-left">
        <h1 className="intro-card-title">Y02 Media-Database</h1>
        <p>This is my little media sanctuary — a personal space where I log everything I’m watching, reading, playing, or collecting.</p>
        <p>It's a blend of the digital and physical: anime I’m watching, games I’m playing, and music I’m collecting, all in one cozy place.</p>
        <p>While it's made for me, I’ve left the door open — so feel free to look around, explore my collection, and maybe even find something new to enjoy.</p>
      </div>
      <div className="intro-right">
        <div className="intro-buttons desktop-only">
          External Pages:
          <a href="https://steamcommunity.com/id/yes102" className="btn btn-secondary">
            <img className="icon" src="/static/icons/steam.svg" alt="Steam" /> My Steam
          </a>
          <a href="https://open.spotify.com/user/vzrhz80re5wgia5axtxit99ep?si=c182b054ac6a4b02" className="btn btn-secondary">
            <img className="icon" src="/static/icons/spotify.svg" alt="Spotify" /> My Spotify
          </a>
          <a href="https://discover.y02.nl" class="btn btn-secondary">
            <img class="icon" alt="Spotify" src="/static/icons/star-solid.svg" />Discover more websites
          </a>
        </div>
        <div className="bottom-action-buttons">
          <Link to="/add-media" className="btn btn-secondary" style={{ height: '30px', width: '250px', marginTop: '0px' }}>
            {isAuthenticated ? (
              <>
                <img className="icon" src="/static/icons/plus-solid.svg" alt="Add" /> Add new Media
              </>
            ) : (
              <>
                <img className="icon" src="/static/icons/star-solid.svg" alt="Recommend" /> Make a Recommendation
                <img className="icon" src="/static/icons/star-solid.svg" alt="Recommend" />
              </>
            )}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default IntroCard;
